import { useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';
import { makeIsEnabled } from '@cast/utils';
import { KentKentrollerStatusDetails } from '@cast/types-kent';

const KENT_KENTROLLER_STATUS_DETAILS_QUERY_KEY =
  'kent-kentroller-status-details';

const getKentrollerStatusDetailsQueryKey = (clusterId?: string) =>
  [KENT_KENTROLLER_STATUS_DETAILS_QUERY_KEY, clusterId] as const;

type Params = {
  clusterId: string;
};

type GetKentrollerStatusQueryArgs = {
  params: Params;
  options?: QueryOptions<KentKentrollerStatusDetails>;
};

export const useGetKentrollerStatusDetails = ({
  params,
  options,
}: GetKentrollerStatusQueryArgs) => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization?.id;

  return useQuery({
    queryKey: getKentrollerStatusDetailsQueryKey(params.clusterId),
    queryFn: async () => {
      const { data } = await apiClient.kent.getKentrollerStatusDetails({
        organizationId: organizationId!,
        clusterId: params.clusterId,
      });

      return data;
    },
    ...options,
    enabled: makeIsEnabled(
      !!organizationId && !!params.clusterId,
      options?.enabled
    ),
  });
};
